import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import axios from "../api/axios";
import "./Dashboard.css";
import DashboardPro from "./DashboardPro";

const Dashboard = ({ user, setIsAuthenticated }) => {
  const navigate = useNavigate();

  const [unreadMail, setUnreadMail] = useState(0);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsAuthenticated(false);
    navigate("/login");
  };

  /* =====================================================
     📧 CARGAR CONTADOR DE CORREOS NO LEÍDOS
  ===================================================== */
  useEffect(() => {
    async function loadUnreadMail() {
      try {
        const r = await axios.get("/mail/unread-count");
        setUnreadMail(r.data.unread || 0);
      } catch (err) {
        console.error("Error cargando correos no leídos:", err);
      }
    }

    loadUnreadMail();
  }, []);

  return (
    <div
      className="dashboard"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, #1f2937, #020617 60%, #000000)",
        color: "white",
        paddingBottom: 40,
      }}
    >
      {/* =====================================================
           🟦 HEADER
      ===================================================== */}
      <header
        style={{
          width: "100%",
          padding: "18px 32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "rgba(15,23,42,0.65)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255,255,255,0.10)",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
          position: "sticky",
          top: 0,
          zIndex: 50,
        }}
      >
        {/* LOGO + TÍTULO */}
        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
          <img src="/corex-logo.png" alt="COREX" style={{ height: 42 }} />
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            Panel principal
          </h1>
        </div>

        {/* USUARIO */}
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span style={{ fontSize: 15 }}>
            Bienvenido,{" "}
            <strong>{user?.nombre_completo || "Usuario"}</strong>
          </span>

          <button
            onClick={handleLogout}
            style={{
              background: "rgba(255,255,255,0.12)",
              padding: "8px 18px",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 10,
              color: "white",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
              backdropFilter: "blur(6px)",
              transition: "0.25s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,0.20)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,0.12)")
            }
          >
            Cerrar sesión
          </button>
        </div>
      </header>

      {/* =====================================================
           🟩 DASHBOARD PRINCIPAL
      ===================================================== */}
      <DashboardPro user={user} unreadMail={unreadMail} />
    </div>
  );
};

export default Dashboard;
